import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { IOnboardingStep } from '~/@api/generated-api-types-user/Api'
import Analytics from '~/@lib_integrations/analytics/analytics'
import { useUser } from '~/@biz_account/useUser/useUser'
import { useOnboarding } from '~/@pages_onboarding/useOnboarding'

type Props = {
  children: React.ReactNode
}

const USER_VERIFIED_PHONE_NUMBER_STORAGE_PREFIX =
  'analytics-once:user-verified-phone-number'

function OnboardingGuard({ children }: Props) {
  const {
    user,
    isLoading,
    currentOnboardingStep,
    isCurrentStepIdentityVerification,
    isCurrentStepAfterPhoneVerification,
    isCurrentStepEqual,
  } = useUser()
  const [localCurrentStep, setLocalCurrentStep] =
    useState<IOnboardingStep | null>(null)
  const { redirectUrl } = useOnboarding(user ?? null)

  // tracking ukoncenia identity verifikacie
  useEffect(() => {
    if (isLoading || isCurrentStepEqual(localCurrentStep)) return

    setLocalCurrentStep(currentOnboardingStep ?? null)

    if (
      !isCurrentStepIdentityVerification &&
      localCurrentStep === IOnboardingStep.IdentityVerificationConfirmed
    ) {
      Analytics.track('veriff-verification-approved')
    }

    if (isCurrentStepAfterPhoneVerification) trackUserVerifiedPhoneNumberOnce()
  }, [
    user,
    isLoading,
    localCurrentStep,
    isCurrentStepIdentityVerification,
    isCurrentStepEqual,
    currentOnboardingStep,
    isCurrentStepAfterPhoneVerification,
  ])

  if (isLoading) return null
  if (redirectUrl) return <Navigate to={redirectUrl} replace />

  return <>{children}</>
}

export { OnboardingGuard }

function trackUserVerifiedPhoneNumberOnce() {
  const storageKey = USER_VERIFIED_PHONE_NUMBER_STORAGE_PREFIX
  try {
    if (localStorage.getItem(storageKey) === '1') return

    localStorage.setItem(storageKey, '1')
  } catch {
    // private mode / quota
  }
  Analytics.track('user-verified-phone-number')
}
